module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-mobile-fca87dc4350d034fb339cbfcaeaab8be.jpg";